/* ===== CP Top Filter Chips (robust, no-freeze, popover with proxy) ===== */
(function () {
  /* ---------- Inject CSS once ---------- */
  if (!document.getElementById('cp-topfilters-style')) {
    var css = `
      .collection-filter{display:flex;align-items:center;gap:12px;padding:8px 12px;border:1px solid #eee;border-radius:10px;position:relative;background:#fff}
      .cp-topfilters{display:flex;align-items:center;gap:12px;width:100%}
      .cp-topfilters__left{display:flex;align-items:center;gap:8px;flex:1 1 auto;min-width:0}
      .cp-topfilters__right{display:flex;align-items:center;gap:8px;margin-left:auto}
      body.cp-filters-enhanced .grid__item--sidebar,
      body.cp-filters-enhanced .collection-sidebar.small--hide{ display:none !important; }

      .cp-topfilters__icon{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:#fff;border:1px solid #eee;cursor:pointer;flex:0 0 auto}
      .cp-topfilters__icon img{width:18px;height:18px;display:block}

      .cp-topfilters__chips{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
      .cp-chip{display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border-radius:999px;border:1px solid #eee;background:#fff;
               font-family:Georgia,"Times New Roman",Times,serif;font-size:16px;line-height:1;color:#1e1e1e;cursor:pointer;white-space:nowrap}
      .cp-chip:hover{box-shadow:0 2px 6px rgba(0,0,0,.05)}
      .cp-chip__caret{transform:translateY(1px)}
      .cp-chip__caret svg{width:14px;height:14px}

      .cp-sort{display:flex;align-items:center;gap:8px;padding:8px 12px;border-left:1px solid #eee;position:relative}
      .cp-sort__icon{width:18px;height:18px}
      .cp-sort__label{font-family:Georgia,"Times New Roman",Times,serif;font-size:16px;color:#1e1e1e}
      .cp-sort select#SortBy {
        position:absolute; inset:0; width:100%; height:100%;
        border:0; background:transparent; color:transparent; text-shadow:0 0 0 transparent;
        -webkit-text-fill-color:transparent; opacity:0; cursor:pointer;
      }
      .cp-sort select#SortBy:focus{outline:none}

      .cp-pop{position:absolute; z-index:60; top:100%; margin-top:8px; min-width:260px; max-width:90vw;
              background:#fff; border:1px solid #eee; border-radius:12px; box-shadow:0 10px 30px rgba(0,0,0,.08); display:none}
      .cp-pop__inner{max-height:55vh; overflow:auto; padding:8px}
      .cp-pop__arrow{position:absolute; top:-8px; width:16px; height:8px; overflow:hidden}
      .cp-pop__arrow:before{content:""; position:absolute; left:0; right:0; margin:auto; width:12px; height:12px; background:#fff;
                            border-left:1px solid #eee; border-top:1px solid #eee; transform:rotate(45deg); top:10px}
      .cp-pop__item{display:flex;align-items:center;gap:10px; width:100%; text-align:left; padding:10px 12px; border-radius:8px; border:1px solid #f2f2f2; background:#fff; cursor:pointer; margin:6px 0}
      .cp-pop__item:hover{background:#fafafa}
      .cp-pop__count{margin-left:auto; color:#888; font-size:13px}

      @media (max-width: 767px){
        .collection-filter{border-radius:12px}
        .cp-chip{padding:8px 12px;font-size:15px}
        .cp-sort__icon{display:none}
      }
    `;
    var style = document.createElement('style');
    style.id = 'cp-topfilters-style';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  /* ---------- Utilities ---------- */
  function $(sel, root){ return (root||document).querySelector(sel); }
  function $all(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function debounce(fn, ms){ var t; return function(){ clearTimeout(t); var a=arguments; t=setTimeout(function(){ fn.apply(null,a); }, ms); }; }

  /* ---------- Main ---------- */
  function enhance() {
    var bar = $('.collection-filter');
    if (!bar || bar.dataset.cpInit === '1') return;

    var wrap = document.createElement('div');
    wrap.className = 'cp-topfilters';

    var left  = document.createElement('div'); left.className  = 'cp-topfilters__left';
    var chips = document.createElement('div'); chips.className = 'cp-topfilters__chips';

    var iconBtn = document.createElement('button');
    iconBtn.type = 'button';
    iconBtn.className = 'cp-topfilters__icon';
    iconBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0121/8376/5088/files/image_9.png?v=1758623296" alt="Filter">';
    iconBtn.addEventListener('click', function(){
      var openDrawer = $('.js-drawer-open-collection-filters');
      if (window.innerWidth <= 1024) { openDrawer && openDrawer.click(); }
      else {
        var groups = getGroups();
        if (groups.length) openChipPopover(groups[0].id, iconBtn);
      }
    });

    left.appendChild(iconBtn);
    left.appendChild(chips);

    var right    = document.createElement('div'); right.className = 'cp-topfilters__right';
    var sortWrap = document.createElement('div'); sortWrap.className = 'cp-sort';
    var sortIc   = document.createElement('img');
    sortIc.className = 'cp-sort__icon';
    sortIc.src = 'https://cdn.shopify.com/s/files/1/0121/8376/5088/files/image_20_1.png?v=1758623296';
    sortIc.alt = 'Sort';
    var sortLabel = document.createElement('span'); sortLabel.className='cp-sort__label'; sortLabel.textContent='Sort';
    var sortSelect = $('#SortBy');
    sortWrap.appendChild(sortIc);
    sortWrap.appendChild(sortLabel);
    if (sortSelect) {
      var lbl = $('label[for="SortBy"]'); if (lbl) lbl.classList.add('visually-hidden');
      sortWrap.appendChild(sortSelect);
    }
    right.appendChild(sortWrap);

    bar.innerHTML = '';
    bar.appendChild(left);
    bar.appendChild(right);

    var pop = document.createElement('div');
    pop.className = 'cp-pop';
    pop.innerHTML = '<div class="cp-pop__arrow"></div><div class="cp-pop__inner"></div>';
    bar.appendChild(pop);
    bar._cpPop = pop;

    document.addEventListener('click', function(e){ if (!bar.contains(e.target)) hidePopover(); });
    window.addEventListener('resize', hidePopover, { passive:true });
    window.addEventListener('scroll', hidePopover, true);

    function getGroups() {
      var groups = $all('#CollectionSidebar .tag-list__header[data-collapsible-id]')
        .map(function(n){ return { id:n.getAttribute('data-collapsible-id'), node:n }; });
      if (!groups.length) {
        groups = $all('#FilterDrawer .tag-list__header[data-collapsible-id]')
          .map(function(n){ return { id:n.getAttribute('data-collapsible-id'), node:n }; });
      }
      groups.forEach(function(g){
        var raw = (g.node.childNodes[0] && g.node.childNodes[0].nodeValue) || g.node.textContent || '';
        g.label = raw.trim();
      });
      return groups.filter(function(g){ return g.id && g.label; });
    }

    function buildChips() {
      var groups = getGroups();
      if (!groups.length) return false;

      chips.innerHTML = '';
      groups.forEach(function(g){
        var btn = document.createElement('button');
        btn.type='button';
        btn.className='cp-chip';
        btn.innerHTML = '<span>'+ g.label +'</span>' +
                        '<span class="cp-chip__caret" aria-hidden="true">' +
                        '<svg viewBox="0 0 28 16" xmlns="http://www.w3.org/2000/svg"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"/></svg></span>';
        btn.addEventListener('click', function(){
          var openDrawer = $('.js-drawer-open-collection-filters');
          var isPrice = /price/i.test(g.id);
          if (window.innerWidth <= 1024 || isPrice) {
            if (openDrawer) {
              openDrawer.click();
              setTimeout(function(){
                var trg = $('#FilterDrawer .tag-list__header[data-collapsible-id="'+g.id+'"]');
                var cnt = $('#FilterDrawer .collapsible-content[data-collapsible-id="'+g.id+'"]');
                if (trg && trg.getAttribute('aria-expanded') !== 'true') trg.click();
                if (cnt) cnt.scrollIntoView({behavior:'smooth', block:'start'});
              }, 250);
            }
          } else {
            openChipPopover(g.id, btn);
          }
        });
        chips.appendChild(btn);
      });

      document.body.classList.add('cp-filters-enhanced');

      return true;
    }

    var ready = buildChips();
    if (!ready) {
      var scopeSidebar = $('#CollectionSidebar');
      var scopeDrawer  = $('#FilterDrawer') || document.body;
      var rebuild = debounce(function(){
        if (buildChips()) {
          if (obs1) obs1.disconnect();
          if (obs2) obs2.disconnect();
        }
      }, 150);
      var obs1 = scopeSidebar ? new MutationObserver(rebuild) : null;
      var obs2 = new MutationObserver(rebuild);
      if (obs1) obs1.observe(scopeSidebar, { childList:true, subtree:true });
      obs2.observe(scopeDrawer,  { childList:true, subtree:true });
      setTimeout(function(){ if (obs1) obs1.disconnect(); obs2.disconnect(); rebuild(); }, 6000);
    }

    bar.dataset.cpInit = '1';

    function hidePopover(){
      if (!bar._cpPop) return;
      bar._cpPop.style.display='none';
      var inner = bar._cpPop.querySelector('.cp-pop__inner');
      inner.innerHTML='';
    }

    function openChipPopover(groupId, anchorEl){
      var container = $('#CollectionSidebar') || $('#FilterDrawer');
      if (!container) return;

      var content = container.querySelector('.collapsible-content[data-collapsible-id="'+groupId+'"] .collapsible-content__inner');
      if (!content) return;

      var items = [];
      $all('.tag-list .tag', content).forEach(function(tag){
        var input = tag.querySelector('input.tag__input');
        if (!input) return;
        var name  = input.getAttribute('name');
        var value = input.getAttribute('value');
        var txt   = (tag.querySelector('.tag__text') || tag).textContent.trim();
        var count = (tag.textContent.match(/\((\d+)\)\s*$/) || [])[1];
        items.push({ type:'input', name:name, value:value, label:txt, count:count });
      });

      var inner = bar._cpPop.querySelector('.cp-pop__inner');
      inner.innerHTML = '';

      if (!items.length) {
        var openDrawer = $('.js-drawer-open-collection-filters');
        hidePopover();
        if (openDrawer) {
          openDrawer.click();
          setTimeout(function(){
            var trg = $('#FilterDrawer .tag-list__header[data-collapsible-id="'+groupId+'"]');
            var cnt = $('#FilterDrawer .collapsible-content[data-collapsible-id="'+groupId+'"]');
            if (trg && trg.getAttribute('aria-expanded') !== 'true') trg.click();
            if (cnt) cnt.scrollIntoView({behavior:'smooth', block:'start'});
          }, 250);
        }
        return;
      }

      items.forEach(function(it){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cp-pop__item';
        btn.innerHTML = '<span>'+ it.label +'</span>' + (it.count ? '<span class="cp-pop__count">'+it.count+'</span>' : '');
        btn.addEventListener('click', function(e){
          e.preventDefault();
          var target = document.querySelector('#FilterDrawer .collapsible-content[data-collapsible-id="'+groupId+'"] input[name="'+cssEscape(it.name)+'"][value="'+cssEscape(it.value)+'"]')
                   || document.querySelector('#CollectionSidebar .collapsible-content[data-collapsible-id="'+groupId+'"] input[name="'+cssEscape(it.name)+'"][value="'+cssEscape(it.value)+'"]');
          if (target) {
            var header = target.closest('.collapsible-content');
            var headerBtn = header ? document.querySelector('[data-collapsible-id="'+groupId+'"].tag-list__header') : null;
            if (headerBtn && headerBtn.getAttribute('aria-expanded') !== 'true') headerBtn.click();
            target.click();

            // NEW: auto-hide collapsible on selection
            var wrapper = target.closest('.collapsible-content');
            if (wrapper && headerBtn && headerBtn.getAttribute('aria-expanded') === 'true') {
              headerBtn.click();
            }

            hidePopover();
          }
        });
        inner.appendChild(btn);
      });

      var aRect = anchorEl.getBoundingClientRect();
      var bRect = bar.getBoundingClientRect();
      var left  = Math.max(8, Math.min(aRect.left - bRect.left, bRect.width - 300));
      bar._cpPop.style.left = left + 'px';
      bar._cpPop.style.display='block';

      var arrow = bar._cpPop.querySelector('.cp-pop__arrow');
      arrow.style.left = (aRect.left - bRect.left + aRect.width/2 - 8) + 'px';
    }

    function cssEscape(str){
      return String(str).replace(/["\\]/g, '\\$&');
    }

    /* ---------- EXTRA: global listener for sidebar/drawer inputs ---------- */
    document.addEventListener('change', function(e){
      if (e.target && e.target.matches('input.tag__input')) {
        var wrapper = e.target.closest('.collapsible-content');
        var headerBtn = wrapper ? document.querySelector('[data-collapsible-id="'+wrapper.getAttribute('data-collapsible-id')+'"].tag-list__header') : null;
        if (headerBtn && headerBtn.getAttribute('aria-expanded') === 'true') {
          headerBtn.click(); // collapse after selection
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
